import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions';
import { PageHeader } from '@openx/components-header/PageHeader';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import { useGoBack } from '../../../hooks/useGoBack';
import { StyledPageContent } from './AudienceDetailsPage.style';
import { AudienceTabs } from './components/AudienceTabs/AudienceTabs';
import { useHeaderMenu } from './hooks/useHeaderMenu';
import { AudienceCriteriaTab } from './tabs/criteria/AudienceCriteriaTab';
import { AudienceDetailsTab } from './tabs/details/AudienceDetailsTab';
import { AudienceInsightsTab } from './tabs/insights/AudienceInsightsTab';
import { AudienceDetailsTabsValues } from './types';

export function AudienceDetailsPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const actions = useHeaderMenu();
  const onGoBack = useGoBack('/audiences');

  return (
    <PageHeader
      title={t('Audience Details')}
      titlePrefix="OpenXSelect"
      goBack={onGoBack}
      backButtonTestId="audience-details-back-button"
      render={() => <HeaderActions actions={actions} />}
    >
      <AudienceTabs />
      <StyledPageContent>
        <Routes>
          <Route path={AudienceDetailsTabsValues.Details} element={<AudienceDetailsTab />} />
          <Route path={AudienceDetailsTabsValues.Criteria} element={<AudienceCriteriaTab />} />
          <Route path={AudienceDetailsTabsValues.Insights} element={<AudienceInsightsTab />} />
          <Route
            path="*"
            element={<Navigate to={`../${AudienceDetailsTabsValues.Details}`} state={location.state} replace />}
          />
        </Routes>
      </StyledPageContent>
    </PageHeader>
  );
}
